var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "PageHeader",
        { attrs: { line: false } },
        [
          _c("el-input", {
            directives: [
              {
                name: "debounce",
                rawName: "v-debounce",
                value: _vm.onSearch,
                expression: "onSearch",
              },
            ],
            attrs: {
              size: "mini",
              "prefix-icon": "el-icon-search",
              placeholder: "Search",
              clearable: "",
            },
            on: { clear: _vm.onSearch },
            model: {
              value: _vm.searchVal,
              callback: function ($$v) {
                _vm.searchVal = $$v
              },
              expression: "searchVal",
            },
          }),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.tableLoading,
              expression: "tableLoading",
            },
          ],
          ref: "table",
          attrs: { data: _vm.tableData, "element-loading-text": "Loading..." },
          on: { "sort-change": _vm.onSortChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "No.",
              width: "95",
              prop: "No",
              sortable: "custom",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "File Name",
              "min-width": "250",
              prop: "FileName",
              sortable: "custom",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "a",
                      { attrs: { href: row.AttachmentPath, target: "_blank" } },
                      [_vm._v(_vm._s(row.FileName))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Content Category",
              "min-width": "180",
              prop: "CategoryName",
              sortable: "custom",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "levelName",
              label: "Security Level",
              sortable: "custom",
              "min-width": "140",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "Hits",
              label: "No.Hits",
              sortable: "custom",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "Download",
              label: "No.Download",
              sortable: "custom",
              "min-width": "140",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "Duration",
              label: "Duration(s)",
              sortable: "custom",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "Pushed Date",
              "min-width": "160",
              prop: "SentOn",
              sortable: "custom",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-wrap" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [10, 25, 50, 100],
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("ViewPaperDialog", {
        attrs: { visible: _vm.viewPaperDialogVisible, data: _vm.rowData },
        on: {
          "update:visible": function ($event) {
            _vm.viewPaperDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
        },
      }),
      _c("ViewCommentDialog", {
        attrs: { visible: _vm.viewCommentDialogVisible, data: _vm.rowData },
        on: {
          "update:visible": function ($event) {
            _vm.viewCommentDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }